import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import { redirect } from '@/helpers/redirects';

/**
 * Parents who are not premium cannot create messages.
 * We can't use requirePremium guard because sitters need messaging access too.
 * @param to - The route object
 * @param _from - The previous route object
 * @param next - The next function to call
 */
export const checkMessagingCreateEligibility = (to: Route, _from: Route, next: NavigationGuardNext) => {
  const account = store.getters['account/getAccount'];
  // Keep query param stable for existing routing dependencies.
  const isRecruitSitter = to.query?.checkAvailability === 'true';
  const redirectPath = account?.isBasic?.() && !isRecruitSitter ? '/upgrade/pricing' : null;

  if (redirectPath) {
    next(false);
    redirect(redirectPath);
    return;
  }

  next();
};

export default checkMessagingCreateEligibility;
